import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_PATH}`

export default {

    ObterAvaliacoesDespesas() {
        return axiosJwt
            .get(`${api}/despesasgerais/avaliacoes`)
            .then(response => {
                return response.data
            })
            .catch( error => {
                return errorHandler(error)
            })
    },

    obterOpcoesFiltros() {
        return axiosJwt
            .get(`${api}/despesasgerais/avaliacoes/opcoesfiltros`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterRelatorioDespesas(tipoRelatorio, filtro) {
        let url = `${api}/despesasgerais/avaliacoes/relatorios/${tipoRelatorio}?fornecedor=${filtro.fornecedor ? filtro.fornecedor : ''
            }&dataCadastroDe=${filtro.dataCadastroDe ? filtro.dataCadastroDe : ''
            }&dataCadastroAte=${filtro.dataCadastroAte ? filtro.dataCadastroAte : ''
            }`
        return axiosJwt
            .get(url, {
                responseType: 'blob'
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
        })
    }
}
